module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_HR-72004c45a564784e82aadc876bc92de2.svg";